<template>
  <div>
    <table-component :dataColumn="dataColumn">
      <template v-slot:header>
        <table-header :title="'ID'" :minWidth="50" />
        <table-header :title="$t('store.name')" :minWidth="100" />
        <table-header :title="$t('store.email')" :minWidth="150" />
        <table-header :title="$t('store.phone')" :minWidth="150" />
        <table-header :title="$t('store.address')" :minWidth="200" />
        <table-header
          :title="$t('common.action')"
          :minWidth="100"
          :width="50"
        />
      </template>
      <template v-slot:body="{ rowData: row, index }">
        <table-cell>{{ index + 1 + (currentPage - 1) * LIMIT }}</table-cell>
        <table-cell>{{ row.name }}</table-cell>
        <table-cell>{{ row.email }}</table-cell>
        <table-cell>{{ formatPhoneNumber(row.phone) }}</table-cell>
        <table-cell>{{ row.address }}</table-cell>
        <table-cell>
          <i class="el-icon-view icon" @click="handleViewDetail(row.id)" />
          <i
            v-if="userInfo.type === ERolAdmin.ADMIN"
            class="el-icon-delete icon"
            @click="handleOpenDeleteDialog(row.id)"
          />
        </table-cell>
      </template>
    </table-component>

    <modal-delete
      :title="null"
      :content="$t('store.textConfirmDeleteStore')"
      :openDeleteDialog="openDeleteDialog"
      :deleteLoading="deleteStoreLoading"
      @handleCloseDialog="handleCloseDeleteDialog"
      @handleConfirm="handleDeleteStore"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { storeService } from '@/services/store.service';
import {
  formatPhoneNumber,
  handleError,
  notifyMessage,
  redirectRouter,
} from '@/helper';
import { LIMIT, PAGE } from '@/constants/common';
import * as pageRouter from '@/constants/pageRouter';
import { ERolAdmin } from '@/enums/user';

const ModalDelete = () => import('@/components/Dialog/DialogConfirm.vue');

export default {
  name: 'TableListStore',
  props: {
    dataColumn: Array,
    currentPage: Number,
  },
  components: { ModalDelete },
  data() {
    return {
      ERolAdmin,
      deleteStoreLoading: false,
      storeIdSelected: null,
      openDeleteDialog: false,
      LIMIT,
    };
  },
  computed: {
    ...mapGetters('store', ['store']),
    ...mapGetters('user', ['userInfo']),
  },
  methods: {
    formatPhoneNumber,
    ...mapActions('store', ['getStoreList']),
    handleOpenDeleteDialog(storeId) {
      this.storeIdSelected = storeId;
      this.openDeleteDialog = true;
    },
    handleCloseDeleteDialog() {
      this.openDeleteDialog = false;
    },
    handleViewDetail(id) {
      redirectRouter({
        path: `/stores/${id}`,
        query: {
          freeText: this.$route.query.freeText,
          page: this.$route.query.page,
        },
      });
    },
    handleDeleteStore() {
      this.deleteStoreLoading = true;

      storeService
        .delete(this.storeIdSelected)
        .then(() => {
          const storeLength = this.store.data.length - 1;

          this.getStoreList({
            freeText: this.$route.query.freeText,
            page:
              storeLength == 0 && +this.$route.query.page > 1
                ? +this.$route.query.page - 1
                : this.$route.query.page || PAGE,
            limit: LIMIT,
          });
          redirectRouter({
            path: pageRouter.STORE,
            query: {
              ...this.$route.query,
              page:
                storeLength == 0 && +this.$route.query.page > 1
                  ? +this.$route.query.page - 1
                  : this.$route.query.page,
            },
          });
          notifyMessage(this.$t('common.deleteSuccess'), 'success');
          this.openDeleteDialog = false;
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.deleteStoreLoading = false;
        });
    },
  },
};
</script>
